import { render, staticRenderFns } from "./WorkRelationLeaveAndLayoffForm.vue?vue&type=template&id=2211820d&scoped=true&"
import script from "./WorkRelationLeaveAndLayoffForm.vue?vue&type=script&lang=ts&"
export * from "./WorkRelationLeaveAndLayoffForm.vue?vue&type=script&lang=ts&"
import style0 from "./WorkRelationLeaveAndLayoffForm.vue?vue&type=style&index=0&id=2211820d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211820d",
  null
  
)

export default component.exports